import { render, staticRenderFns } from "./ShelfRowNew.vue?vue&type=template&id=79cd4f2a&"
import script from "./ShelfRowNew.vue?vue&type=script&lang=js&"
export * from "./ShelfRowNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports